import {FormControl, FormGroup} from "@angular/forms";
import {addressModelFactory} from "../../address/address.model";
import {contactModelFactory} from "../../contact/contact.model";
import {TARGET_SYSTEM} from "../../helpers/app-constants";
import {ContractAccountRequests} from "../../project/project.model";
import { masterAgreementStatusValues } from "../../project/master-agreement-status";

export class DeliveryOpsInformationModel extends FormGroup {
  constructor() {
    super({
      csa: new FormControl(),
      ampId: new FormControl(),
      msId: new FormControl(),
      customerErpNumber: new FormControl(),
      opgNumber: new FormControl(),
      orderAcceptance: new FormControl(),
      // legacy forms
      initialBillingDate: new FormControl(),
      billingStart: new FormControl(),
      enableCatalogPricing: new FormControl(),
      // finish legacy forms
      salesOrganization: new FormControl(),
      orderAcceptanceDisableReason: new FormControl(), // Only used upon a disable
      orderAcceptanceCompleteDate: new FormControl(),
      currency: new FormControl(),
      customerBpId: new FormControl(),
      contractAccountId: new FormControl(),
      contractAccountCategory: new FormControl(),
      paymentTerms: new FormControl(),
      currentMaStatus: new FormControl(),
      correspondenceVariant: new FormControl(),
      accountDeterminationId: new FormControl(),
      companyCodeGroup: new FormControl(),
      standardCompanyCode: new FormControl(),
      outgoingPaymentMethod: new FormControl(),
      invoiceScheduling: new FormControl(),
      // Simplify
      maStartDate: new FormControl(),
      maStartDatePicker: new FormControl(),
      commercialityCode: new FormControl(),
      globalDeal: new FormControl(),
      globalDealClassification: new FormControl(),
      deployementCountry: new FormControl(),
      inadvanceInarrears: new FormControl(),
      podRequired: new FormControl(),
      allowFutureInstallDates: new FormControl(),
      defaultContractAccountId: new FormControl(),
      billToAddressId: new FormControl(),
      soldToAddressId: new FormControl(),
      payerAddressId: new FormControl(),
      endUserAddressId: new FormControl(),
      endCustomerAddressId: new FormControl(),
      billToContactId: new FormControl(),
      invoiceContactId: new FormControl(),
      hpInvoiceContactId: new FormControl(),
      hpSalesRepContactId: new FormControl(),
      hpContractAdminContactId: new FormControl(),
      hpAccDeliveryMgrContactId: new FormControl(),
      sameAsLocation: new FormControl(),
      // simplify top card
      billingFrequency: new FormControl(),
      billingCycle: new FormControl(),
      coTerminous: new FormControl(),
      coTerminousDate: new FormControl(),
      coTerminousDatePicker: new FormControl(),
      vendorContractAccNumber: new FormControl(),
      // Dor
      legacyReportedDate: new FormControl(),
      legacyReportedDatePicker: new FormControl(),
      prepaidFieldOnDorTab: new FormControl(),
      multiYearPoType: new FormControl(),
      multiYearTermDuration: new FormControl(),
      renewal: new FormControl(),
      previousDocument: new FormControl(),
      legacyDocumentType: new FormControl(),
      legacyDocumentNumber: new FormControl(),
      // Splits
      billingModelSplit: new FormControl(),
      businessModelSplit: new FormControl(),
      chargeTypeSplit: new FormControl(),
      endUserSplit: new FormControl(),
      purchaseOrderSplit: new FormControl(),
      shipToSplit: new FormControl(),
      titleStatusSplit: new FormControl(),
      customerPoNumber: new FormControl(),
      customerPoNoDescription: new FormControl(),
      customerPoItemNo: new FormControl(),
      saLetter: new FormControl(),
      supplyRoutingId: new FormControl(),
      billFromStructure: new FormControl(),
      selectedBillFrom: new FormControl(),
      billFromBPIDId: new FormControl(),
    });
  }

  public parseProjectJson(project?: any, isPMPSP = false, globalOpportunityId = null, c2cDeploymentCountry?: any ) {
    const billToAddress = addressModelFactory(project.billToAddress);
    const soldToAddress = addressModelFactory(project.soldToAddress);
    const payerAddress = addressModelFactory(project.payerAddress);
    const endUserAddress = addressModelFactory(project.endUserAddress);
    const endCustomerAddress = addressModelFactory(project.endCustomerAddress);

    const sameAs = payerAddress && billToAddress && payerAddress.id && payerAddress.id === billToAddress.id;

    const billToContact = contactModelFactory(project.billToContact);
    const invoiceContact = contactModelFactory(project.invoiceContact);
    const hpInvoiceContact = contactModelFactory(project.hpInvoiceContact);
    const hpSalesRepContact = contactModelFactory(project.hpSalesRepContact);
    const hpContractAdminContact = contactModelFactory(project.hpContractAdminContact);
    const hpAccDeliveryMgrContact = contactModelFactory(project.hpAccDeliveryMgrContact);

    const values = { // NOTE I put these in the same order as above for better tracking
      csa: project.csa || "",
      ampId: project.ampId || project.opportunityId || "",
      msId: project.msId || "",
      customerErpNumber: project.customerErpNumber || "",
      opgNumber: project.opgNumber || "",
      orderAcceptance: project.orderAcceptance === false ? false : (project.orderAcceptance || ""),
      initialBillingDate: project.initialBillingDate === false ? false : (project.initialBillingDate || ""),
      billingStart: project.billingStart,
      enableCatalogPricing: project.enableCatalogPricing || false,
      salesOrganization: project.salesOrganization || null,
      orderAcceptanceDisableReason: "",
      orderAcceptanceCompleteDate: project.orderAcceptanceCompleteDate || "",
      currency: project.currency || "",
      customerBpId: (isPMPSP ? project.resellerBpId : project.customerBpId) || "",
      contractAccountId: project.contractAccountId || "",
      contractAccountCategory: project.contractAccountCategory || "",
      paymentTerms: project.paymentTerms || "",
      currentMaStatus: project.currentMaStatus || "",
      correspondenceVariant: project.correspondenceVariant || "",
      accountDeterminationId: project.accountDeterminationId || "",
      companyCodeGroup: project.companyCodeGroup || "",
      standardCompanyCode: project.standardCompanyCode || "",
      outgoingPaymentMethod: project.outgoingPaymentMethod || "",
      invoiceScheduling: project.invoiceScheduling || "",
      // Simplify
      maStartDate: project.maStartDate || "",
      maStartDatePicker: project.maStartDate || "",
      commercialityCode: project.commercialityCode,
      globalDeal: project.globalDeal || false,
      globalDealClassification: project.globalDealClassification,
      inadvanceInarrears: project.inadvanceInarrears,
      podRequired: project.podRequired || false,
      allowFutureInstallDates: project.allowFutureInstallDates || false,
      defaultContractAccountId: project.defaultContractAccountId || "",
      billToAddressId: (billToAddress && billToAddress.id) || null,
      soldToAddressId: (soldToAddress && soldToAddress.id) || null,
      payerAddressId: (payerAddress && payerAddress.id) || null,
      endUserAddressId: (endUserAddress && endUserAddress.id) || null,
      endCustomerAddressId: (endCustomerAddress && endCustomerAddress.id) || null,
      billToContactId: (billToContact && billToContact.id) || null,
      invoiceContactId: (invoiceContact && invoiceContact.id) || null,
      hpInvoiceContactId: (hpInvoiceContact && hpInvoiceContact.id) || null,
      hpSalesRepContactId: (hpSalesRepContact && hpSalesRepContact.id) || null,
      hpContractAdminContactId: (hpContractAdminContact && hpContractAdminContact.id) || null,
      hpAccDeliveryMgrContactId: (hpAccDeliveryMgrContact && hpAccDeliveryMgrContact.id) || null,
      sameAsLocation: sameAs,
      // simplify top card
      billingFrequency: project.billingFrequency,
      billingCycle: project.billingCycle || "",
      coTerminous: project.coTerminous,
      coTerminousDate: project.coTerminousDate || "",
      coTerminousDatePicker: project.coTerminousDate || "",
      vendorContractAccNumber: project.vendorContractAccNumber,
      // dor
      legacyReportedDate: project.legacyReportedDate,
      legacyReportedDatePicker: project.legacyReportedDate,
      prepaidFieldOnDorTab: project.prepaidFieldOnDorTab,
      multiYearPoType: project.multiYearPoType,
      multiYearTermDuration: project.multiYearTermDuration,
      renewal: project.renewal || "O",
      previousDocument: project.previousDocument || "0",
      legacyDocumentType: project.legacyDocumentType,
      legacyDocumentNumber: project.legacyDocumentNumber || "",
      // splits
      billingModelSplit: !!project.billingModelSplit,
      businessModelSplit: !!project.businessModelSplit,
      chargeTypeSplit: !!project.chargeTypeSplit,
      endUserSplit: !!project.endUserSplit,
      purchaseOrderSplit: project.purchaseOrderSplit, // dorData
      shipToSplit: project.shipToSplit, // dorData
      titleStatusSplit: !!project.titleStatusSplit,
      customerPoNumber: project.customerPoNumber || (project.purchaseOrderSplit === "NONE" ? "per signed SOW" : ""),
      customerPoNoDescription: project.customerPoNoDescription || (project.purchaseOrderSplit === "NONE" ? "N/A" : ""),
      customerPoItemNo: project.customerPoItemNo || (project.purchaseOrderSplit === "NONE" ? "N/A" : ""),
      saLetter: project.saLetter || "",
      supplyRoutingId: project.supplyRoutingId || "",
      billFromStructure: project.billFromStructure || "",
      selectedBillFrom: project.selectedBillFrom || "",
      billFromBPIDId: project.billFromBPIDId || "",
      deployementCountry: c2cDeploymentCountry || "",
    };
    this.setValue(values);
  }

  public constructProject(address: any, itsmContacts: any, globalOpportunityId) {
    const buildingAddress = address[0].partnerBuildingAddress && address[0].partnerBuildingAddress.length > 0 &&
    (address[0].targetSystem === TARGET_SYSTEM.MIGRATION_IPSO_PAGE ||
    address[0].targetSystem === TARGET_SYSTEM.PMPS_PAGE ||
    address[0].targetSystem === TARGET_SYSTEM.MP_FLEX_RESELL ||
    address[0].targetSystem === TARGET_SYSTEM.SELL_THROUGH ||
    address[0].targetSystem === TARGET_SYSTEM.BILL_THROUGH ||
    address[0].targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH ||
    address[0].targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH ||
    address[0].targetSystem === TARGET_SYSTEM.CHANNEL_DAAS ||
    address[0].targetSystem === TARGET_SYSTEM.MIGRATION_CHANNEL_DAAS ||
    address[0].target_system === TARGET_SYSTEM.MCS_SELL_THROUGH || 
    address[0].target_system === TARGET_SYSTEM.MCS_BILL_THROUGH) ?
      address[0].partnerBuildingAddress : address[0].customerBuildingAddress;
    const enduserAddress = address[0].customerBuildingAddress && address[0].customerBuildingAddress.length > 0 ?
      address[0].customerBuildingAddress : [];
    const project: any = {
      targetSystem: address[0].targetSystem,
      billFromStructure: address[0].billFromStructure,
      billFromBPIDId:address[0].billFromBPIDId,
      country: address[0].country,
      billToAddress: buildingAddress.filter(_types =>
        _types.types === "billTo").find(_id => _id.id === address[0].bill_to_address_id),
      soldToAddress: buildingAddress.filter(_types =>
        _types.types === "soldTo").find(_id => _id.id === address[0].sold_to_address_id),
      payerAddress: buildingAddress.filter(_types =>
        _types.types === "payer").find(_id => _id.id === address[0].payer_address_id),
      endUserAddress: enduserAddress.filter(_types =>
        _types.types === "endUser").find(_id => _id.id === address[0].end_user_address_id),
      id: address[0].id,
      isMpc: address[0].isMpc,
      itsmCustomerId: address[0].itsmCustomerId,
      resellerCustomerId: address[0].resellerCustomerId,
      rejected: address[0].rejected,
      coTerminous: address[0].coTerminous,
      sourceDocumentationLink: address[0].sourceDocumentationLink,
      resellerBpId: address[0].resellerBpId,
      customerBpId: address[0].customerBpId,
      currentMaStatus: address[0].currentMaStatus === masterAgreementStatusValues.maintenance.typeId? address[0].lastMAStatus :address[0].currentMaStatus,
      mpcContactsAddressesBpids: address[0].mpcContactsAddressesBpids,
      defaultContractAccountId: address[0].defaultContractAccountId,
      orderAcceptance: address[0].orderAcceptance,
      orderAcceptanceCompleteDate: address[0].orderAcceptanceCompleteDate,
      billingFrequency: address[0].billingFrequency,
      billingCycle: address[0].billingCycle,
      currency: address[0].currency,
      maStartDate: address[0].maStartDate,
      saLetter: address[0].saLetter,
      coTerminousDate: address[0].coTerminousDate,
      legacyReportedDate: address[0].legacyReportedDate,
      billingStart: address[0].billingStart,
      purchaseOrderSplit: address[0].purchaseOrderSplit,
      csa: address[0].csa,
      ampId: address[0].ampId,
      opportunityId: address[0].opportunityId,
      customerErpNumber: address[0].customerErpNumber,
      opgNumber: address[0].opgNumber,
      vendorContractAccNumber: address[0].vendorContractAccNumber,
      commercialityCode: address[0].commercialityCode,
      globalDealClassification: address[0].globalDealClassification,
      dorData: address[0].dorData,
      initialBillingDate: address[0].initialBillingDate,
      orderAcceptanceDisableReason: address[0].orderAcceptanceDisableReason,
      billingModelSplit: address[0].billingModelSplit,
      businessModelSplit: address[0].businessModelSplit,
      chargeTypeSplit: address[0].chargeTypeSplit,
      globalDeal: address[0].globalDeal,
      podRequired: address[0].podRequired,
      endUserSplit: address[0].endUserSplit,
      titleStatusSplit: address[0].titleStatusSplit,
      salesOrganization: address[0].salesOrganization,
      enableCatalogPricing: address[0].enableCatalogPricing,
      inadvanceInarrears: address[0].inadvanceInarrears,
      supplyRoutingId: address[0].supplyRoutingId,
    };
    project.companyCodeGroup = address[0].extended_childrens.length ?
      address[0].extended_childrens[0].salesOrganization || address[0].extended_childrens[0].validSorg : null;
    project.standardCompanyCode = address[0].extended_childrens.length ?
      address[0].extended_childrens[0].salesOrganization || address[0].extended_childrens[0].validSorg : null;
    project.contractDuration = address[0].extended_childrens.length ?
      address[0].extended_childrens[0].contractDuration : null;
    project.billToContact = itsmContacts ?
      itsmContacts.find(x => (x.id ? x.id === address[0].bill_to_contact_id : [])) : null;
    project.invoiceContact = itsmContacts ?
      itsmContacts.find(x => (x.id ? x.id === address[0].invoice_contact_id : [])) : null;
    project.hpInvoiceContact = itsmContacts ?
      itsmContacts.find(x => (x.id ? x.id === address[0].hp_invoice_contact_id : [])) : null;
    project.hpSalesRepContact = itsmContacts ?
      itsmContacts.find(x => (x.id ? x.id === address[0].hp_sales_rep_contact_id : [])) : null;
    project.hpContractAdminContact = itsmContacts ?
      itsmContacts.find(x => (x.id ? x.id === address[0].hp_contract_admin_contact_id : [])) : null;
    project.hpAccDeliveryMgrContact = itsmContacts ?
      itsmContacts.find(x => (x.id ? x.id === address[0].hp_acc_delivery_mgr_contact_id : [])) : null;
    const isDassProject = project.targetSystem === TARGET_SYSTEM.DAAS || project.targetSystem === TARGET_SYSTEM.MANAGED_COLLABORATION_SERVICES  || project.targetSystem === TARGET_SYSTEM.DIGITAL_SERVICE;
    const isMigrationProject = project.targetSystem === TARGET_SYSTEM.MIGRATION_IPSO_COMPLETE ||
    project.targetSystem === TARGET_SYSTEM.MIGRATION_IPSO_DIRECT_MPS ||
    project.targetSystem === TARGET_SYSTEM.MIGRATION_IPSO_PAGE ||
    project.targetSystem === TARGET_SYSTEM.MIGRATION_ORION;
    const buildDefaultSRID = proj => `${proj.opportunityId}_${(proj.targetSystem || "").toUpperCase()}`;
    const defaultValues: any = {
      commercialityCode: ["EMEA", "APJ"].includes(project.geo_region_id) ? "N" : "1",
      globalDealClassification: "NA",
      inadvanceInarrears: "ADV",
      billingFrequency: "MNTH",
      vendorContractAccNumber: "0",
      purchaseOrderSplit: "NONE",
      ampId: !isDassProject ? project.ampId || project.opportunityId : project.ampId,
      supplyRoutingId: buildDefaultSRID(project),
    };

    if (globalOpportunityId) {
      defaultValues.globalDealClassification = "";
      defaultValues.globalDeal = "";
    } else {
      defaultValues.globalDealClassification = "NA";
      defaultValues.globalDeal = "LC";
    }
    const defaultDorValues = {
      legacyReportedDate: isMigrationProject ? null : "2099-12-31",
      legacyReportedThruDate: "2099-12-31",
      legacyDocumentType: isMigrationProject ? null : "NONE",
      legacyDocumentNumber: isMigrationProject ? null : "0000000",
      prepaidFieldOnDorTab: "N",
      multiYearPoType: "N",
      multiYearTermDuration: isMigrationProject ? null : project.contractDuration,
      renewal: isMigrationProject ? "M" : "O",
      previousDocument: "0000000",
      shipToSplit: "N",
      deployementCountry: "NZ"
    };
    Object.keys(defaultDorValues).forEach((k) => {
      if (!project.dorData[k]) {
        project.dorData[k] = defaultDorValues[k];
      }
      if (k === "multiYearTermDuration") {
        if (project.dorData[k] && project.dorData[k] > defaultDorValues[k]) {
          project.dorData[k] = project.dorData[k];
        }
      }
    });
    Object.keys(defaultValues).forEach((k) => {
      if (!project[k]) {
        project[k] = defaultValues[k];
      }
    });
    return project;
  }

  public exportDeliveryOpsInformation(projectId) {
    const project = this.value;
    return {
      project: {id: projectId, ...project},
    };
  }
}

export interface CADetailsModel {
  activeCAExists: boolean;
  pendingCADetails: ContractAccountRequests[];
  pendingCAExists: boolean;
}
